export const SYNC_SENSOR_NOTIFICATIONS = '@@sensorNotifications/syncSensorNotifications'
export const UPDATE_SENSOR_NOTIFICATIONS = '@@sensorNotifications/updateSensorNotifications'
